import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import filesCollection from 'modules/bookkeepers/store/collections/files'
import incidenceMessagesCollection from 'modules/bookkeepers/store/collections/incidenceMessages'

interface Params {
  incidenceId: string
  isBookkeeperView: boolean
}

const useFetchIncidenceMessages = ({ incidenceId, isBookkeeperView }: Params) => {
  const params = {
    data: {
      incidence_id: incidenceId,
      bookkeeper_view: isBookkeeperView,
    },
  }

  const { loading } = useAsyncData(() => {
    return Promise.all([incidenceMessagesCollection.fetch(params), filesCollection.fetch(params)])
  }, [incidenceId, isBookkeeperView])

  return {
    loading,
    incidenceMessagesCollection,
    filesCollection,
  }
}

export default useFetchIncidenceMessages
